export const CONTACTS_PER_COMPANY_DEFAULT_PLACEHOLDER = 5;
export const CONTACTS_PER_COMPANY_LIMIT_INPUT_DEBOUNCE_MS = 300;

export const CONTACTS_PER_COMPANY_LIMIT_TRANSLATIONS = {
    prefix: "si.advanced_search.filters.contacts_per_company_filter.label.prefix",
    suffix: "si.advanced_search.filters.contacts_per_company_filter.label.suffix",
    textInputErrorMessage: "si.advanced_search.filters.contacts_per_company_filter.input.error",
} as const;
